
import React from "react";
import Button from '../../Buttons/Button'
import moment from 'moment'

export default function TimerModule (props) {
    return (
            <div class={"col-md-3"}>
            <label className={props.disabled ? "mt-3":""}>{props.time !== "" ? moment(props.time).format('MMMM Do YYYY, hh:mm') : ""}</label>
            {!props.disabled && <Button
                buttonName ={props.buttonName}
                onClick = {props.updatePatternCheck}
            /> }
            </div>
        )
}


// WEBPACK FOOTER //
// ./src/components/SampleRequest/TimerModule/index.js